// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"232":"ea08372f","789":"5c79a9b5","859":"e6142b50","871":"cba9b4d8","914":"7512bd0f","968":"35e3bf92"}[chunkId] + ".chunk.css";
};